import { EntityType } from '../../../@types/entityTypes';
import instanceQuery from '../../queries/product/MaterialQuery.graphql';
import workspaceQuery from '../../queries/product/MaterialWorkspaceQuery.graphql';
import defaultQuery from '../../queries/product/MaterialDefault.graphql';
import fragment from '../../fragments/product/MaterialFragment.graphql';
import mutationQuery from '../../mutations/product/MaterialMutation.graphql';

const Material: EntityType = {
  type: 'Material',
  title: 'Materials',
  formTitle: 'Material',
  formUrl: '/Products/EPR/Material/Details/',
  workspaceUrl: '/Products/EPR/Material/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment: fragment,
  dropdown: {
    query: workspaceQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  screenReference: 'MATERIAL',
};

export default Material;
